var _this = this;
import * as tslib_1 from "tslib";
import { LikeNotificationData, onLikeNotificationClicked } from 'owa-header-app-notifications';
import { getSelectedTableView } from 'owa-mail-list-store';
import { getCurrentTableMailboxInfo } from 'owa-mail-mailboxinfo';
import { lazyMoveReadingPaneToTab } from 'owa-mail-reading-pane-store';
import { getStore as getMailStore } from 'owa-mail-store';
import { loadConversation, loadItem } from 'owa-mail-store-actions';
import { orchestrator } from 'satcheljs';
export default orchestrator(onLikeNotificationClicked, function (message) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var notification, listViewType, cachedConversation, conversationId, cachedItem, itemId, itemId_1;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                notification = message.notification;
                listViewType = getSelectedTableView().tableQuery.listViewType;
                if (!(listViewType === 0 /* Conversation */)) return [3 /*break*/, 3];
                cachedConversation = getMailStore().conversations.get(notification.conversationId);
                conversationId = {
                    Id: notification.conversationId,
                    mailboxInfo: getCurrentTableMailboxInfo(),
                };
                if (!!cachedConversation) return [3 /*break*/, 2];
                // make a get convesation item call if the data is not already available in cache
                return [4 /*yield*/, loadConversation(conversationId, 'LoadLikedConversation')];
            case 1:
                // make a get convesation item call if the data is not already available in cache
                _a.sent();
                _a.label = 2;
            case 2:
                openItemInNewTab(conversationId, notification.subject);
                return [3 /*break*/, 6];
            case 3:
                cachedItem = getMailStore().items.get(notification.itemId);
                itemId = {
                    Id: notification.itemId,
                    mailboxInfo: getCurrentTableMailboxInfo(),
                };
                if (!(cachedItem && cachedItem.NormalizedBody)) return [3 /*break*/, 4];
                openItemInNewTab(itemId, notification.subject);
                return [3 /*break*/, 6];
            case 4:
                itemId_1 = {
                    Id: notification.itemId,
                    mailboxInfo: getCurrentTableMailboxInfo(),
                };
                return [4 /*yield*/, loadItem(itemId_1, 'LoadLikedItem')];
            case 5:
                _a.sent();
                openItemInNewTab(itemId_1, notification.subject);
                _a.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}); });
function openItemInNewTab(rowId, rowSubject) {
    // Open the RowId (Conversation or Item) on the reading pane
    lazyMoveReadingPaneToTab.importAndExecute(rowId, rowSubject, [] /* categories */, true /* makeActive */, null /* instrumentation context */);
}
export { LikeNotificationData };
//# sourceMappingURL=onLikeNotificationClicked.js.map